import { listSessions } from "@/commands/sessions/list-sessions";
import { sendSessionMessage } from "@/commands/session/send-session-message";
import { showLogs } from "@/commands/show/show-logs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

/**
 * The session actions with their own command. Anything absent here is a
 * per-session operation and goes through `runSessionOperation`, which resolves
 * the session id first.
 */
export const sessionActions: Record<
  string,
  (parsed: ParsedArgs, asJson: boolean) => Promise<void>
> = {
  list: (parsed) => listSessions(parsed),
  logs: (parsed) => showLogs(parsed),
  send: sendSessionMessage,
};
